/**
 * Получаем уникальный хэш пользователя для сторисов
 * @return machineId - идентификатор inAppStory
 */
export const getInAppStoriesId = () => {
  let machineId = localStorage.getItem('InAppStoriesId')

  if (!machineId) {
    machineId = crypto.randomUUID()
    localStorage.setItem('InAppStoriesId', machineId)
  }

  return machineId
}
